import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
export const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/80 backdrop-blur-md shadow-sm' : 'bg-transparent'}`} data-id="element-51">
      <div className="container mx-auto px-6 lg:px-12" data-id="element-52">
        <nav className="flex items-center justify-between py-6" data-id="element-53">
          <a href="#" className="text-2xl font-light tracking-tight" data-id="element-54">
            WELLHAUS™
          </a>
          <div className="hidden md:flex items-center space-x-8" data-id="element-55">
            <a href="https://form.typeform.com/to/rfYM00cT" target="_blank" rel="noopener noreferrer" className="px-6 py-2.5 bg-gray-900 text-white text-sm font-medium rounded-full hover:bg-gray-800 transition-colors" data-id="element-56">
              Request a Demo
            </a>
            <a href="https://calendly.com/-smartsoda/discoverycall" target="_blank" rel="noopener noreferrer" className="px-6 py-2.5 text-sm font-medium text-gray-700 hover:text-gray-900 transition-colors" data-id="element-57">
              Talk to Our Team
            </a>
          </div>
          <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="md:hidden p-2" data-id="element-58">
            {mobileMenuOpen ? <XIcon size={24} data-id="element-59" /> : <MenuIcon size={24} data-id="element-60" />}
          </button>
        </nav>
      </div>
      {mobileMenuOpen && <div className="md:hidden bg-white border-t border-gray-100" data-id="element-61">
          <div className="px-6 py-6 space-y-4" data-id="element-62">
            <a href="https://form.typeform.com/to/rfYM00cT" target="_blank" rel="noopener noreferrer" className="block text-center px-6 py-3 bg-gray-900 text-white text-sm font-medium rounded-full" onClick={() => setMobileMenuOpen(false)} data-id="element-63">
              Request a Demo
            </a>
            <a href="https://calendly.com/-smartsoda/discoverycall" target="_blank" rel="noopener noreferrer" className="block text-center px-6 py-3 text-sm font-medium text-gray-700" onClick={() => setMobileMenuOpen(false)} data-id="element-64">
              Talk to Our Team
            </a>
          </div>
        </div>}
    </header>;
};